import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let PageNester = class PageNester extends Vue {
};
__decorate([
    Prop(String)
], PageNester.prototype, "name", void 0);
PageNester = __decorate([
    Component
], PageNester);
export default PageNester;
